import { ConfigProvider } from 'antd';
import 'antd/dist/antd.less';
import React, { useEffect, useState, lazy } from 'react';
import { Provider, useSelector } from 'react-redux';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';

import { ThemeProvider } from 'styled-components';
import ProtectedRoute from './components/utilities/protectedRoute';
import config from './config/config';
import store from './redux/store';

import Admin from './routes/admin';
import Company from './routes/company';
import Filer from './routes/filer';
import Auth from './routes/auth';
import ERMD from './routes/ermd';
import SOD from './routes/sod';

import { useAuth } from './context/AuthProvider';
import './static/css/style.css';
import RoleRedirect from './components/utilities/roleRedirect';
import Register from './container/profile/authentication/overview/register';
import EnrollmentCompany from './container/profile/authentication/overview/enrollCompany';
import EnrollFiler from './container/profile/authentication/overview/enrollFiler';
import Expiration from './components/system/ExpirationModal';
import ForgotPassword from './container/profile/authentication/overview/ForgotPassword';
import ResendValidation from './container/profile/authentication/overview/resendValidation';
import TemporaryCredentials from './container/profile/authentication/overview/TemporaryCreds';
import PrivacyNotice from './container/profile/authentication/overview/PrivacyNotice';
import FAQHome from './container/profile/authentication/overview/faqs/FaqsHome';
import Disclaimer from './container/profile/authentication/overview/Disclaimer';
import SelectRole from './container/profile/authentication/overview/SelectRole';
import SuccessfullyEnrolled from './container/profile/authentication/overview/successfullyEnrolled';
import EmailActivated from './container/profile/authentication/overview/emailActivated';

const NotFound = lazy(() => import('./container/pages/404'));
// const SelectRole = lazy(() => import('./container/profile/authentication/overview/SelectRole'));

const { themeColor } = config;

function ProviderConfig() {
  // layout/theme settings redux
  const { rtl, topMenu, mainContent } = useSelector((state) => ({
    rtl: state.ChangeLayoutMode.rtlData,
    topMenu: state.ChangeLayoutMode.topMenu,
    mainContent: state.ChangeLayoutMode.mode,
  }));

  const { user } = useAuth();
  const isLoggedIn = !!user;

  return (
    <ConfigProvider direction={rtl ? 'rtl' : 'ltr'}>
      <ThemeProvider theme={{ ...themeColor, rtl, topMenu, mainContent }}>
        <Router>

          <Expiration />
          <Routes>
            {!isLoggedIn && <Route path="/*" element={<Auth />} />}

            {!isLoggedIn && (
              <>
                <Route path="/" element={<Auth />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/register" element={<Register />} />
                <Route path="/enroll-company" element={<EnrollmentCompany />} />
                <Route path="/enroll-filer" element={<EnrollFiler />} />
                <Route path="/resend-validation" element={<ResendValidation />} />
                <Route path="/temporary-credentials" element={<TemporaryCredentials />} />
                <Route path="/privacy-notice" element={<PrivacyNotice />} />
                <Route path="/faqs" element={<FAQHome />} />
                <Route path="/disclaimer" element={<Disclaimer />} />
                <Route path="/successfully-enrolled" element={<SuccessfullyEnrolled />} />
                <Route path="/email-activated" element={<EmailActivated />} />
                <Route path="/*" element={<Auth />} /> {/* catch all goes last */}
              </>
            )}
            {/* logged in routes */}
            {isLoggedIn && (
              <>
                <Route path="/" element={<RoleRedirect />} />
                <Route path="/select-role" element={<SelectRole />} />
                {/* <Route path="/enroll-company" element={<EnrollmentCompany />} />
                <Route path="/enroll-filer" element={<EnrollFiler />} /> */}
                <Route path="/admin/*" element={<ProtectedRoute Component={Admin} />} />
                <Route path="/company/*" element={<ProtectedRoute Component={Company} />} />
                <Route path="/filer/*" element={<ProtectedRoute Component={Filer} />} />
                <Route path="/ermd/*" element={<ProtectedRoute Component={ERMD} />} />
                <Route path="/sod/*" element={<ProtectedRoute Component={SOD} />} />
                <Route path="*" element={<NotFound />} />
              </>
            )}
          </Routes>
        </Router>
      </ThemeProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <Provider store={store}>
      <ProviderConfig />
    </Provider>
  );
}

export default App;
